import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";
import { TranslationModule } from "../i18n/translation.module";
import { KeycloakAuthorizationService } from "../keycloak-authz-angular/core/services/keycloak-authorization.service";
import { KeycloakAuthzAngularModule } from "../keycloak-authz-angular/keycloak-authz-angular.module";
import { AuthGuard } from "./auth.guard";
import { initializer } from "./keycloak-initializer";
import { AuthService } from "./_services/auth.service";

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    TranslationModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    KeycloakAngularModule,
    KeycloakAuthzAngularModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      multi: true,
      deps: [KeycloakService, KeycloakAuthorizationService],
    },
    AuthGuard,
    AuthService
  ]
})
export class AuthModule {}
